import React from 'react';
import { inject } from 'mobx-react';

import CreditCardDisplay from 'js/components/core/CreditCardDisplay';
import Container from './Container';
import VFDAccountDisplay from 'js/components/core/VFDAccountDisplay';

export default inject('page')(({ page }) => (
  <Container>
    {page.bank_account.isFilledIn && (
      <VFDAccountDisplay bankAccount={page.bank_account} onEdit={page.openModal} />
    ) || (
        <CreditCardDisplay creditCard={page.credit_card} onEdit={page.openModal} />
      )
    }
  </Container>
));
